import { Component, computed, signal } from "@angular/core";
import { BaseComponent } from "src/app/components/base/base.component";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";
import { ErrorResponse } from "src/app/core/models/error";
import { AppNotificationService } from "src/app/core/services/app-notification.service";
import { LogoutService } from "src/app/core/services/logout.service";
import { AppService } from "src/services/app.service";
import { AdminService } from "./../../modules/admins/services/admin.service";
import { ClickOutsideDirective } from "blu-utilities";

@Component({
  selector: "app-user-menu",
  templateUrl: "./user-menu.component.html",
  styleUrl: "./user-menu.component.scss",
  imports: [AddClassModifierDirective, ClickOutsideDirective],
})
export class UserMenuComponent extends BaseComponent {
  isSideBarCollapsed$ = this.appService.getNavBarCollapsedObservable();
  isSideBarCollapsed = this.appService.isSideBarCollapsed;
  readonly showContent = signal(false);

  readonly adminFullName = computed(() => {
    const name = this.adminService.getAdminFullName();
    return this.isSideBarCollapsed()
      ? this.adminService.getAdminInitials()
      : name;
  });

  constructor(
    appNotificationService: AppNotificationService,
    private logoutService: LogoutService,
    private adminService: AdminService,
    private appService: AppService,
  ) {
    super(appNotificationService);
  }

  setShowContent(value: boolean) {
    this.showContent.set(value);
  }

  toggleShowContent() {
    this.setShowContent(!this.showContent());
  }

  showEditPasswordModal() {
    this.appService.setIsEditPasswordModalOpen(true);
    this.setShowContent(false);
  }

  getAdminProfilePicture() {
    return this.adminService.getAdminProfilePicture();
  }

  isAllowedToEditPassword() {
    return !this.adminService.isAllowedToLoginByOAuthOnly();
  }

  logout() {
    this.setComponentLoading(true);
    this.logoutService.logout({ skipReturnUrl: true }).subscribe({
      next: () => {
        this.setComponentLoading(false);
        this.setShowContent(false);
      },
      error: (error: ErrorResponse) => {
        this.handleErrorResponse(error);
        this.setComponentLoading(false);
      },
    });
  }
}
